// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23aZ1","buttons":"Footer_buttons__2nDcf"};